export default "__VITE_ASSET__DhQtCffa__"